// src/components/Contact/Contact.js
// import React, { useState, useRef } from 'react';
// import emailjs from '@emailjs/browser';
// import './Contact.css';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState(null);
//   const formRef = useRef();

//    const socialLinks = {
//     linkedin: "https://www.linkedin.com/in/habiba-shahidi-440304216/",
//     github: "https://github.com/Habiba-Shahidi",
//     portfolio: "https://693695f19520bfc07ef563f8--habibareact.netlify.app"
//   };

  
//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setSubmitStatus(null);

//     // Using EmailJS browser SDK
//     emailjs.sendForm(
//       process.env.REACT_APP_EMAILJS_SERVICE_ID ,
//       process.env.REACT_APP_EMAILJS_TEMPLATE_ID ,
//       formRef.current,
//       process.env.REACT_APP_EMAILJS_PUBLIC_KEY 
//     )
//     .then((result) => {
//       console.log('Email successfully sent!', result.text);
//       setSubmitStatus('success');
//       setFormData({
//         name: '',
//         email: '',
//         subject: '',
//         message: ''
//       });
//     })
//     .catch((error) => {
//       console.error('Failed to send email:', error.text);
//       setSubmitStatus('error');
//     })
//     .finally(() => {
//       setIsSubmitting(false);
      
//       // Clear status message after 5 seconds
//       setTimeout(() => {
//         setSubmitStatus(null);
//       }, 5000);
//     });
//   };

//   return (
//     <section id="contact" className="contact">
//       <div className="container">
//         <h2 className="section-title">Contact Me</h2>
//         <div className="contact-container">
//           <div className="contact-info">
//             <h3>Let's Talk About Your Project</h3>
//             <p>Feel free to reach out if you're looking for a developer, have a question, or just want to connect.</p>
//             <div className="contact-item">
//               <i className="fas fa-envelope"></i>
//               <div>habibashahidi64@gmail.com</div>
//             </div>
//             <div className="contact-item">
//               <i className="fas fa-phone"></i>
//               <div>+971 505125092 </div>
//             </div>
//             <div className="contact-item">
//               <i className="fas fa-map-marker-alt"></i>
//               <div>Abu Dhabi, UAE</div>
//             </div>
//             <div className="social-links">
//               <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-link"><i className="fab fa-linkedin-in"></i></a>
//               <a href={socialLinks.github} target="_blank" rel="noopener noreferrer" className="social-link"><i className="fab fa-github"></i></a>
//               <a href="#"><i className="fab fa-instagram"></i></a>
//                <a href={socialLinks.portfolio} target="_blank" rel="noopener noreferrer" className="social-link">
//                 <i className="fas fa-globe"></i>
//               </a>
//             </div>
//           </div>
//           <div className="contact-form">
//             {submitStatus === 'success' && (
//               <div className="alert alert-success">
//                 <i className="fas fa-check-circle"></i> Thank you for your message! I will get back to you soon.
//               </div>
//             )}
//             {submitStatus === 'error' && (
//               <div className="alert alert-error">
//                 <i className="fas fa-exclamation-circle"></i> Sorry, there was an error sending your message. Please try again or contact me directly at habiba@example.com.
//               </div>
//             )}
//             <form ref={formRef} onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <label htmlFor="name">Your Name</label>
//                 <input 
//                   type="text" 
//                   id="name" 
//                   name="name" 
//                   value={formData.name}
//                   onChange={handleChange}
//                   required 
//                   disabled={isSubmitting}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="email">Your Email</label>
//                 <input 
//                   type="email" 
//                   id="email" 
//                   name="email" 
//                   value={formData.email}
//                   onChange={handleChange}
//                   required 
//                   disabled={isSubmitting}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="subject">Subject</label>
//                 <input 
//                   type="text" 
//                   id="subject" 
//                   name="subject" 
//                   value={formData.subject}
//                   onChange={handleChange}
//                   required 
//                   disabled={isSubmitting}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="message">Your Message</label>
//                 <textarea 
//                   id="message" 
//                   name="message" 
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                   disabled={isSubmitting}
//                 ></textarea>
//               </div>
//               <button 
//                 type="submit" 
//                 className="btn btn-primary"
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? (
//                   <>
//                     <i className="fas fa-spinner fa-spin"></i> Sending...
//                   </>
//                 ) : (
//                   <>
//                     <i className="fas fa-paper-plane"></i> Send Message
//                   </>
//                 )}
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };


// export default Contact;


// src/components/Contact/Contact.js
import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, Linkedin, Github, Globe, Instagram, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import emailjs from '@emailjs/browser';
import './Contact.css';
import { FaGithub, FaLinkedin, FaGlobe, FaInstagram } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const formRef = useRef();

  const socialLinks = {
    linkedin: "https://www.linkedin.com/in/habiba-shahidi-440304216/",
    github: "https://github.com/Habiba-Shahidi",
    portfolio: "https://habibareact.netlify.app",
    instagram: "https://www.instagram.com/habiba_grid?igsh=MTZzOXYybm8zNHV2MA%3D%3D"
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      formRef.current,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then((result) => {
      console.log('Email successfully sent!', result.text);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    })
    .catch((error) => {
      console.error('Failed to send email:', error.text);
      setSubmitStatus('error');
    })
    .finally(() => {
      setIsSubmitting(false);
      
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Get In Touch</span>
          <h2 className="section-title">Let's Build Something Amazing</h2>
          <p className="section-description">
            Have a project in mind? Let's discuss how we can work together to bring your ideas to life.
          </p>
        </div>

        <div className="contact-grid">
          {/* Contact Info Card */}
          <motion.div 
            className="contact-info-card"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h3 className="contact-info-title">Contact Information</h3>
            <p className="contact-info-description">
              Feel free to reach out for collaboration, opportunities, or just a friendly chat about tech!
            </p>
            
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <Mail size={20} />
                </div>
                <div className="contact-content">
                  <h4>Email</h4>
                  <a href="mailto:habibashahidi64@gmail.com" className="contact-link">
                    habibashahidi64@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <Phone size={20} />
                </div>
                <div className="contact-content">
                  <h4>Phone</h4>
                  <a href="tel:+971505125092" className="contact-link">
                    +971 505125092
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <MapPin size={20} />
                </div>
                <div className="contact-content">
                  <h4>Location</h4>
                  <span>United Arab Emirates (UAE)</span>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="social-section">
              <h4>Connect With Me</h4>
              <div className="social-links">
                <motion.a 
                  href={socialLinks.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link linkedin"
                  whileHover={{ y: -5 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Linkedin size={20} />
                </motion.a>
                
                <motion.a 
                  href={socialLinks.github} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link github"
                  whileHover={{ y: -5 }}
                  whileTap={{ scale: 0.95 }}
                >
             <FaGithub size={20} />
                </motion.a>
                
                <motion.a 
                  href={socialLinks.portfolio} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link portfolio"
                  whileHover={{ y: -5 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Globe size={20} />
                </motion.a>
                
                <motion.a 
                  href={socialLinks.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link instagram"
                  whileHover={{ y: -5 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Instagram size={20} />
                </motion.a>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div 
            className="contact-form-card"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3 className="form-title">Send a Message</h3>
            
            {/* Status Messages */}
            {submitStatus === 'success' && (
              <motion.div 
                className="alert success"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
              >
                <CheckCircle size={20} />
                <span>Thank you! Your message has been sent successfully. I'll get back to you soon.</span>
              </motion.div>
            )}
            
            {submitStatus === 'error' && (
              <motion.div 
                className="alert error"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
              >
                <AlertCircle size={20} />
                <span>Oops! Something went wrong. Please try again or contact me directly via email.</span>
              </motion.div>
            )}

            <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">
                    <span className="label-text">Your Name</span>
                    <span className="required">*</span>
                  </label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    value={formData.name}
                    onChange={handleChange}
                    required 
                    disabled={isSubmitting}
                    placeholder="Enter your name"
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">
                    <span className="label-text">Email Address</span>
                    <span className="required">*</span>
                  </label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    value={formData.email}
                    onChange={handleChange}
                    required 
                    disabled={isSubmitting}
                    placeholder="Enter your email"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">
                  <span className="label-text">Subject</span>
                  <span className="required">*</span>
                </label>
                <input 
                  type="text" 
                  id="subject" 
                  name="subject" 
                  value={formData.subject}
                  onChange={handleChange}
                  required 
                  disabled={isSubmitting}
                  placeholder="What is this regarding?"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  <span className="label-text">Your Message</span>
                  <span className="required">*</span>
                </label>
                <textarea 
                  id="message" 
                  name="message" 
                  value={formData.message}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  placeholder="Tell me about your project or inquiry..."
                  className="form-textarea"
                  rows="5"
                ></textarea>
              </div>

              <motion.button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {isSubmitting ? (
                  <>
                    <Loader2 size={20} className="spinner" />
                    <span>Sending Message...</span>
                  </>
                ) : (
                  <>
                    <Send size={20} />
                    <span>Send Message</span>
                  </>
                )}
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;